import { Image } from "@/components/shared/image";

export default function Trophy() {
  return (
    <div className="relative">
      <Image src={"/assets/prize.png"} width={80} height={80} alt="prize" />
    </div>
  );
}
